import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FieldComponent } from '../../field/field.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'app-change-language',
    templateUrl: './change-language.component.html',
    styleUrls: ['./change-language.component.css'],
    standalone: false
})
export class ChangeLanguageComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<FieldComponent>,
  public dialog: MatDialog,
  public translate: TranslateService) { }

  ngOnInit(): void {
  }

  changeLang() {
    this.dialogRef.close({"option": "changeLang"});
  }

  cancel(): void {
    this.dialogRef.close({"option": "cancel"})
  }

}
